import { render, staticRenderFns } from "./post-meta-item.vue?vue&type=template&id=eb54dc9c&lang=pug&"
import script from "./post-meta-item.vue?vue&type=script&lang=js&"
export * from "./post-meta-item.vue?vue&type=script&lang=js&"
import style0 from "./post-meta-item.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports